/**<!-- The core Firebase JS SDK is always required and must be listed first -->
<script src="https://www.gstatic.com/firebasejs/7.21.1/firebase-app.js"></script>

<!-- TODO: Add SDKs for Firebase products that you want to use
     https://firebase.google.com/docs/web/setup#available-libraries -->
<script src="https://www.gstatic.com/firebasejs/7.21.1/firebase-analytics.js"></script>

<script>
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyCADuli_FKLrt1os8iUGYGkqAEpcEbGJ3w",
    authDomain: "portfolio-1b636.firebaseapp.com",
    databaseURL: "https://portfolio-1b636.firebaseio.com",
    projectId: "portfolio-1b636",
    storageBucket: "portfolio-1b636.appspot.com",
    messagingSenderId: "295049191915",
    appId: "1:295049191915:web:a7d6cebfc20c2d0920f9ae",
    measurementId: "G-M0MMJETJMS"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
</script>
*/

const config = {
    apiKey: "AIzaSyCADuli_FKLrt1os8iUGYGkqAEpcEbGJ3w",
    authDomain: "portfolio-1b636.firebaseapp.com",
    databaseURL: "https://portfolio-1b636.firebaseio.com",
    projectId: "portfolio-1b636",
    storageBucket: "portfolio-1b636.appspot.com",
    messagingSenderId: "295049191915",
    appId: "1:295049191915:web:a7d6cebfc20c2d0920f9ae",
    measurementId: "G-M0MMJETJMS"
  };

export default config;